
import ConfigScene from './ConfigScene';

class ItemsHelper {
  constructor() {
    // vars
    this.items = [];
    this.activeItem = null;
    this.helpBullets = false; // true/false - to switch help bullets
    this.hitFound = false;
    this.hitEnabled = true; // to prevent in touch mode

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // loop lsn
    aScene.signals.loopCall.add(this.loop, this);
  }

  // --------------------------------------------------------------
  // Loop
  // --------------------------------------------------------------

  loop() {
    if (aScene.sceneManager.sceneState === 0) {
      // hit test
      this.hitFound = false;
      if (!aScene.infoBubble.overCheck() && this.hitEnabled) {
        for (let i = 0; i < this.items.length; i += 1) {
          if (this.items[i].tryHit()) {
            this.hitFound = true;
            // save item reference
            this.activeItem = this.items[i];
            // cursor
            aScene.iManager.setPointerCursor(true);
            // hover call
            aScene.signals.itemCall.dispatch(ConfigScene.E_ITEM_HOVER, this.activeItem.itemId);
            break;
          }
        }
      }

      // no hit found -> try un-hover
      if (!this.hitFound) {
        this.deSelectItem();
      }
    }
  }

  // --------------------------------------------------------------
  // Select
  // --------------------------------------------------------------

  trySelectItem() {
    if (this.activeItem) {
      if (aPage.features.isTouch && !aPage.features.isMouse) {
        if (this.activeItem.touchUps > 0) {
          this.selectItem();
        } else {
          this.activeItem.touchUps += 1;
        }
      } else {
        this.selectItem();
      }
    }
  }

  deSelectItem() {
    if (this.activeItem) {
      this.activeItem = null;
      // cursor
      aScene.iManager.setPointerCursor(false);
      // un-hover
      aScene.signals.itemCall.dispatch(ConfigScene.E_ITEM_HOVER, -1);
    }
  }

  selectItem() {
    if (!aPage.isArchive) {
      // cursor
      aScene.iManager.setPointerCursor(false);
      // un-hover
      aScene.signals.itemCall.dispatch(ConfigScene.E_ITEM_HOVER, -1);
      // bubble event
      aScene.signals.infoCall.dispatch(
        ConfigScene.E_INFO_BLL_SHOW,
        [this.activeItem.itemId, this.activeItem.getBulletPos()],
      );
      // reset active item
      this.activeItem = null;
    }
  }
}

export default ItemsHelper;



// WEBPACK FOOTER //
// ./src/js/scene/helpers/ItemsHelper.js